import { render, staticRenderFns } from "./VersionHistoryXlsx.vue?vue&type=template&id=c58528be"
import script from "./VersionHistoryXlsx.vue?vue&type=script&lang=js"
export * from "./VersionHistoryXlsx.vue?vue&type=script&lang=js"
import style0 from "./VersionHistoryXlsx.vue?vue&type=style&index=0&id=c58528be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports